DO.Subscribe('app:ready', function (e, $) {
	function init() {
		attachEvents();
	}

	function attachEvents() {
		var keys = [];
		keys[13] = 'enter';
		keys[32] = 'space';
		keys[9] = 'tab';
		keys[27] = 'esc';
		keys[38] = 'up';
		keys[40] = 'down';
		keys[37] = 'left';
		keys[39] = 'right';

		/**
         * Makes main menu controllable by keyboard
         */
		$(document.activeElement).keydown(function (e) {
			handleKeydown(e, keys);
		});
	}

	function handleLeftUp(target, e) {
		// Main menu focus
		if ($(target).attr('role') === 'menu' || $(target).attr('role') === 'submenu') {
			e.preventDefault();
			$(target).find('li:last').focus();
		}
		// Menu item
		if ($(target).attr('role') === 'menuitem') {
			e.preventDefault();
			$(target).prev('li').focus();
		}
	}

	function handleRightDown(target, e) {
		// Main menu focus
		if ($(target).attr('role') === 'menu' || $(target).attr('role') === 'submenu') {
			e.preventDefault();
			$(target).find('li:first').focus();
		}
		// Menu item
		if ($(target).attr('role') === 'menuitem') {
			e.preventDefault();
			$(target).next('li').focus();
		}
	}

	function handleEnterSpace(target, e) {
		// Menu item
		if ($(target).attr('role') === 'menuitem') {
			e.preventDefault();
			var link = $(target).find('a');
			if (link && $(link).attr('href')) {
				window.location = $(link).attr('href');
			}
		}
	}

	function handleKeydown(e, keys) {
		var target = e.target,
			key = e.which;

		// Left arrow + up
		if (keys[key] === 'left' || keys[key] === 'up') {
			handleLeftUp(target, e);
		}

		// Right arrow + down
		if (keys[key] === 'right' || keys[key] === 'down') {
			handleRightDown(target, e);
		}

		// Enter + Space
		if (keys[key] === 'enter' || keys[key] === 'space') {
			handleEnterSpace(target, e);
		}
	}

	init();
});

DO.Subscribe('app:ready', function(e, $) {
	/**
     * Animate scroll to anchor
     */
	$('a[href*=\\#]').click(function(event) {
		var url = $(event.target).attr('href'),
			hash = url.substring(url.indexOf('#') + 1),
			target = $('a[name=' + hash + ']');

		if (target.length > 0) {
			event.preventDefault();
			$('html, body').animate({
				scrollTop: $(target).offset().top
			}, 500, function() {
				if (history.pushState) {
					history.pushState(null, null, url);
				} else {
					window.location = url;
				}
			});
		}
	});
});

//* Print function
// eslint-disable-next-line no-unused-vars
function printSection(selector) {
	var content = '',
		baseURL = $('base').attr('href');

	// Build content by querying the DOM via selector passed
	if ($.isArray(selector)) {
		$.each(selector, function (index, el) {
			content += $(el).html();
		});
	} else {
		content = $(selector).html();
	}
	// Build HTML to print
	$.ajax({
		type: 'GET',
		url: baseURL + 'home/GetPrintTemplate',
		complete: function (response) {
			var html = response.responseText,
				page = html.replace('[content]', content);
			setTimeout(function() {
				printPage(page);
			}, 200);
		}
	});
}

function printPage(page) {
	var target = $('#printDiv'),
		fullPage = $('#pageContent');

	target.removeClass('print-only--triggerable');
	fullPage.addClass('no-print'); // hide all other page content from print
	target.html(page);

	setTimeout(function() {
		window.print();
		target.empty();
		target.addClass('print-only--triggerable');
		fullPage.removeClass('no-print'); // hide all other page content from print
	}, 500);
}

DO.Subscribe('app:ready', function(e, $) {
	function init() {
		setup();
	}

	function setup() {
		$('.address-finder-field').each(function () {
			attachAutocomplete(this);

			// Current approach to disabling auto complete in chrome
			$(this).attr({
				autocomplete: 'chrome-off',
				spellcheck: 'false'
			});
		});
	}

	function attachAutocomplete(self) {
		var form = $(self).closest('form'),
			wrap = $(self).closest('.field-wrap'),
			showLoading = function () {
				$(wrap).addClass('field-wrap--loading');
			},
			hideLoading = function () {
				$(wrap).removeClass('field-wrap--loading');
			};

		$(self).autocomplete({
			serviceUrl: '/AddressFinder/getAddress',
			minChars: 3,
			showNoSuggestionNotice: true,
			noSuggestionNotice: 'No results found',
			deferRequestBy: 1,
			transformResult: function (response) {
				return getSuggestions(response);
			},
			onSearchStart: function () {
				showLoading();
			},
			onSearchComplete: function () {
				hideLoading();
			},
			onSelect: function (suggestion) {
				hideLoading();

				if (typeof suggestion.data.UnitType === typeof undefined) {
					$(this).val(suggestion.data.Line1);
				} else {
					$(this).val(suggestion.data.Line1 + ', ' + suggestion.data.Line2);
				}

				$(form).find('input[name="PropertyRegion"]').val(suggestion.data.SuburbName);
				$(form).find('input[name="PropertyCity"]').val(suggestion.data.TownCity);
				$(form).find('input[name="PropertyPostCode"]').val(suggestion.data.PostCode);
			}
		});
	}

	function getSuggestions(response) {
		return {
			suggestions: $.map(JSON.parse(response), function (dataItem) {
				return {
					value: dataItem.value['address'],
					data: {
						'ID': dataItem.data.ID,
						'Line1': dataItem.data.Line1,
						'Line2': dataItem.data.Line2,
						'UnitType': dataItem.data.UnitType,
						'SuburbName': dataItem.data.SuburbName,
						'TownCity': dataItem.data.TownCity,
						'PostCode': dataItem.data.PostCode
					}
				};
			})
		};
	}

	init();
});

DO.Subscribe('app:ready', function(e, $) {
	function init() {
		if ($('[data-type-alert]').length < 1) {
			return;
		}

		checkCookie($('[data-type-alert]'));
		attachEvents();
	}

	function attachEvents() {
		var dismiss = $('[data-alert-dismiss]');

		dismiss.on('click', function() {
			var alert = $(this).closest('[data-type-alert]');
			dismissAlert(alert);
		});
	}

	/**
     * Handle really long notifications
     * Note: this will kill the animation, as it removes max-height, but it's a super edgecase
     *
     * @param DOMObject | alert
     */
	function adjustHeight(alert) {
		setTimeout(function() {
			var height = alert.css('max-height', 'none').height();

			if (height < 250) {
				alert.css('max-height', '');
			}
		}, 500);
	}

	/**
     * @param DOMObject | alert
     */
	function dismissAlert(alert) {
		alert.addClass('alert--hidden');

		setTimeout(function() {
			removeAlert(alert);
			setCookie('alertseen' + alert.attr('id'), true);
		}, 500);
	}

	/**
     * Removes alert from the DOM, and adjusts parent object if needed
     * @param DOMObject | alert
     */
	function removeAlert(alert) {
		var parent = alert.closest('.hasalert');
		if (parent.length > 0) {
			parent.removeClass('hasalert');
		}
		alert.remove();
	}

	/**
     * If Cookie exists for this alert, then the user has already dismissed it,
     * remove the alert from the DOM.
     * If a cookie doesn't exist, then show the alert
     *
     * @param DOMObjects | alerts
     */
	function checkCookie(alerts) {
		var i = 0,
			alert,
			cookie;

		for (i = 0; i < alerts.length; i = i + 1) {
			alert = $(alerts[i]);

			cookie = getCookie('alertseen' + alert.attr('id'));

			if (cookie) {
				removeAlert(alert);
			} else {
				alert.removeClass('alert--hidden');
				adjustHeight(alert);
			}
		}
	}

	/**
     * @param String | key, Mixed | value
     */
	function setCookie(key, value) {
		var expires = new Date(),
			cookiePath = '/';
		expires.setTime(expires.getTime() + (200 * 24 * 60 * 60 * 1000));

		document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + '; path=' + cookiePath;
	}

	/**
     * @param String | key
     */
	function getCookie(key) {
		var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
		return keyValue ? keyValue[2] : false;
	}

	init();
});

DO.Subscribe('app:ready', function(e, $) {
	function init() {
		setup();
	}

	function setup() {
		$('.locale-page-selector__select').select2({
			placeholder: 'Choose Language',
			allowClear: true,
			width: 'style',
			minimumResultsForSearch: 30,
			dropdownCssClass: 'select-dropdown-container',
			dropdownAdapter: $.fn.select2.amd.require('CustomDropdownAdapter')
		});

		$('.locale-selector-file__select').select2({
			placeholder: 'Download a translation',
			allowClear: true,
			width: 'style',
			minimumResultsForSearch: 30,
			dropdownCssClass:
                'select-dropdown-container select-dropdown-container__file'
		});

		attachEvents();
	}

	function attachEvents() {
		$('.locale-selector').on('change', function () {
			var data = $(this).select2('data');
			window.location.href = data[0].id;
		});
	}

	init();
});

DO.Subscribe('app:ready', function(e, $) {
	var initialTenants = $('.fieldgroup__tenant');

	function init() {
		setup();
	}

	function setup() {
		setupLandlordToggle();
		setupTenants();
		attachEvents();
	}

	function attachEvents() {
		$('input.field__money').keypress(function(event) {
			var controlKeys = [8, 9, 13],
				isControlKey = controlKeys.join(',').match(new RegExp(event.which)),
				ignoreEvent = !event.which || (event.which >= 48 && event.which <= 57),
				eventNotFound = !event.which || (event.which === 46 && $(this).val() && $(this).val().indexOf('.') === -1);

			// if, is number, carry on at normal
			if (ignoreEvent || eventNotFound || isControlKey) { // Opera assigns values for control keys.
				return true;
			}

			// prevent non numeric
			event.preventDefault();
		});
	}

	/**
     * Reveal landlord details when not the same as primary contact
     */
	function setupLandlordToggle() {
		var landlordToggle = $('input[data-landlord-toggle]'),
			landlordFieldGroup = landlordToggle.parents('.fieldgroup')
				.eq(1).find('.fieldgroup__landlord'),
			inputs;

		if (landlordToggle.length < 1 || landlordFieldGroup.length < 1) {
			return false;
		}

		landlordFieldGroup.toggle(!landlordToggle.is(':checked'));
		inputs = landlordFieldGroup.find(':input');

		attachLandlordToggle(landlordToggle, landlordFieldGroup, inputs);

		landlordToggle.trigger('change');
	}

	function attachLandlordToggle(landlordToggle, landlordFieldGroup, inputs) {
		landlordToggle.on('change', function () {
			if (landlordToggle.is(':checked')) {
				landlordFieldGroup.slideUp(200, function () {
					inputs.each(function () {
						// empty value
						$(this).val('').prop('disabled', true);

						// reset parsley validation of fields
						if (typeof $(this).parsley !== typeof undefined) {
							$(this).parsley().reset();
						}
					});
				});
			} else {
				inputs.each(function () {
					// empty value
					$(this).prop('disabled', false);
				});

				landlordFieldGroup.slideDown(200);
			}
		});
	}

	function toggleTenant(added, addTenantTrigger, showLastRemoveButton) {
		var visible = $('.fieldgroup__tenant:visible'),
			visibleLength = (added + 1) || visible.length;

		// disable add-tenant button if > 5 tenants added
		if (visibleLength > 5) {
			addTenantTrigger
				.slideUp(200, function () {
					$(this)
						.addClass('disabled hidden')
						.prop('disabled', true);
				});
		} else {
			addTenantTrigger
				.slideDown(200, function () {
					$(this)
						.removeClass('disabled hidden')
						.prop('disabled', false);
				});
		}

		showLastRemoveButton();
	}

	function showRemove() {
		var visible = $('.fieldgroup__tenant:visible');

		// hide all remove buttons except the last
		// note: the first tenant doens have a remove button in its DOM
		visible.not(':last')
			.find('button[data-action="remove-tenant"]')
			.slideUp(200, function () {
				$(this)
					.addClass('disabled hidden')
					.prop('disabled', true);
			});

		// show the last tenant's remove button
		visible.last()
			.find('button[data-action="remove-tenant"]')
			.slideDown(200, function () {
				$(this)
					.removeClass('disabled hidden')
					.prop('disabled', false);
			});
	}

	function removeTenant(button, addTenantTrigger, toggleTenantsTrigger) {
		var tenant = $(button).closest('.fieldgroup__tenant');

		tenant.slideUp(200, function () {
			// clear fields
			$(this).find(':input')
				.val('')
				.addClass('disabled')
				.prop('disabled', true);
			// focus add field button
			addTenantTrigger.focus();
			toggleTenantsTrigger();
		});
	}

	function addTenant(button, toggleTenantsTrigger) {
		// Find out how many tenants are visible
		var tenants = $(button).closest('.fieldgroup').find('.fieldgroup__tenant'),
			current = tenants.filter(':visible').length,
			next = current,
			nextWrapper,
			i; // eq() is zero based

		// Reveal the next one if any
		if (next > 5) {
			return false;
		}

		nextWrapper = tenants.eq(next);
		i = next + 1;

		// ensure tenant name required only when visible
		nextWrapper.find('input[name="TenantName_' + i + '"]')
			.attr('required', 'required')
			.attr('aria-required', 'true')
			.attr('data-parsley-required', 'true')
			.attr('data-parsley-required-message', 'Please enter a name');
		nextWrapper.find('label').first().addClass('label-required');

		nextWrapper.slideDown(200, function () {
			var input = $(this).find('input');
			input.attr('aria-hidden', false).prop('disabled', false);
			input.first().focus();
			toggleTenantsTrigger(next);
		});
	}

	function showInitialTenants(initialTenants) {
		$.each(initialTenants, function (index, tenant) {
			var tenantName = $(tenant).find('input[data-tenant-phone]').val();
			if (tenantName && tenantName.length > 0) {
				$(tenant).show();
			}
		});
	}

	/**
     * Show hidden tenants on page load
     * if name is filled
     */
	function setupTenants() {
		if (initialTenants.length < 1) {
			return;
		}

		showInitialTenants(initialTenants);

		// Reveal tenant field when click add tenant
		var addTenantTrigger = $('button[data-action="add-tenant"]'),
			removeTenantTriggers = $('button[data-action="remove-tenant"]'),

			// Initialise the trigger to avoid it being disabled on refresh page.
			toggleTenantsTrigger = function (added) {
				toggleTenant(added, addTenantTrigger, showLastRemoveButton);
			},

			// show all remove tenant buttons except the last
			showLastRemoveButton = function () {
				showRemove();
			},

			// trigger for remove tenant
			onRemoveTenant = function (button) {
				removeTenant(button, addTenantTrigger, toggleTenantsTrigger);
			},

			// show next tenant, up to 6
			onAddTenant = function (button) {
				addTenant(button, toggleTenantsTrigger);
			};

		// bind remove tenant event
		removeTenantTriggers
			.on('click.removetenant', function () {
				onRemoveTenant(this);
			});

		// trigger for add another tennat
		addTenantTrigger
			.removeClass('disabled')
			.prop('disabled', false)
			.on('click.addtenant', function () {
				onAddTenant(this);
			});

		toggleTenantsTrigger();
	}

	init();
});

/*
 Restore main menu visibility when switching form portrait to landscape
 */
DO.Subscribe(['app:breakpointchange'], function(e, $) {
	function init() {
		var breakpoint = DO.CurrentBreakpoint(),
			large = ['large', 'xlarge', 'xxlarge', 'xxxlarge'];

		if ($.inArray(breakpoint, large)) {
			$('.header .header_nav ul').not(':visible').css('display', '');
		}
	}

	init();
});

/**
* Custom JS for the landinggrid module
*/
DO.Subscribe(['app:ready'], function(e, $) {
	'use strict';

	function init() {
		attachEvents();
	}

	function attachEvents() {
		var title = $('.landinggrid_title');
		// Enable tile border color change when hovering over tile title
		// Note: this is not exactly proper becaus eof the html structure
		// But we like to please the designers
		title.on('mouseover', function (e) {
			$(this).parents('.landinggrid_section').addClass('hover');
		});

		title.on('mouseout', function (e) {
			$(this).parents('.landinggrid_section').removeClass('hover');
		});
	}

	init();
});

DO.Subscribe(['app:ready'], function (e, $) {
	$('#languageModal').modal();
});

DO.Subscribe(['app:ready'], function(e, $) {
	/**
     * Mobile Nav
     */

	var menuLink = $('.mobile_nav_link a'),
		menuControl = $('.mobile_nav_chevron'),
		trigger = $('.nav_open_button'),
		overlay = $('.nav_overlay'),
		ctrlClose = overlay.find('button.nav_close');

	// Open a link's submenu when it's clicked
	menuLink.click(function(e) {
		var link = $(this),
			menu = link.siblings('.mobile_nav_list'),
			item = link.closest('.mobile_nav_link');

		// Close any open sibling menus
		closeOpenMenus(item);

		// Only call toggleMenu if the menu isn't open already, otherwise just follow the link
		if (menu.length > 0 && !link.parent().hasClass('mobile_nav_link--active')) {
			e.preventDefault();
			toggleMenu(menu);
		}
	});

	// Toggle a link's submenu when it's chevron is clicked
	menuControl.click(function() {
		var link = $(this).siblings('a'),
			menu = link.siblings('.mobile_nav_list'),
			item = link.closest('.mobile_nav_link');

		// Close any open sibling menus
		closeOpenMenus(item);

		if (menu.length > 0) {
			toggleMenu(menu);
		}
	});

	function toggleMenu(menu) {
		menu.stop().slideToggle('fast').toggleClass('mobile_nav_list--open');
		menu.closest('.mobile_nav_link').toggleClass('mobile_nav_link--active');

		if (menu.hasClass('mobile_nav_list--open')) {
			menu.attr('aria-hidden', 'false');
		} else {
			menu.attr('aria-hidden', 'true');
		}
	}

	function closeOpenMenus(item) {
		var menu = item.siblings().children('.mobile_nav_list--open:not(.mobile_nav_list--first)');

		menu
			.slideToggle('fast')
			.removeClass('mobile_nav_list--open')
			.attr('aria-hidden', 'true')
			.closest('li').removeClass('mobile_nav_link--active');
	}

	function openNav(evt) {
		evt.preventDefault();
		overlay.css('visibility', 'visible');
		overlay.addClass('open');
		overlay.animate({'scrollTop': 0}, 500);
		$('html').addClass('overlay-opened');
		$('.aria-main-content').attr('aria-hidden', true).attr('tabindex', -1);
		overlay.attr('aria-hidden', false);
		ctrlClose.focus();
	}

	function closeNav(evt) {
		overlay.css({'top': '', 'bottom': ''});
		overlay.removeClass('open');
		setTimeout(function() {
			$('html').removeClass('overlay-opened');
			$('.aria-main-content').attr('aria-hidden', false).attr('tabindex', 0);
			overlay.attr('aria-hidden', true);
			overlay.css('visibility', 'hidden');
		}, 500);
	}

	$(trigger).on('click', function(e) {
		openNav(e);
	});

	$(ctrlClose).on('click', function(e) {
		closeNav(e);
	});
});

DO.Subscribe('app:ready', function(e, $) {
	function init() {
		attachEvents();
	}

	function attachEvents() {
		$('.link_action__pdf').on('click', function(e) {
			var pdfLink = $(this),
				currentUrl = window.location.href;

			if (currentUrl.indexOf('?') !== -1) {
				e.preventDefault();
				doAppend(currentUrl, pdfLink);
			}
		});
	}
	/**
     * Append URL parameters to PDF export link in case they've
     * been updated by decisiontree or anything else
     **/
	function doAppend(currentUrl, pdfLink) {
		var urlArray = currentUrl.split('?'),
			pdfHref = pdfLink.attr('href'),
			pdfHrefArray;

		// Replace params in pdf link with current params or append if no params exist
		if (pdfHref.indexOf('?') !== -1) {
			pdfHrefArray = pdfHref.split('?');
			window.location = pdfHrefArray[0] + '?' + urlArray[1];
		} else {
			window.location = pdfHref + '?' + urlArray[1];
		}
	}

	init();
});

DO.Subscribe(['app:ready', 'ajax:success'], function(e, $) {
	function init() {
		$('.rating').each(function() {
			var el = $(this);

			setup(el);
		});
	}

	function setup(el) {
		attachEvents(el);
		updateChecked(el);
	}

	function attachEvents(el) {
		var stars = el.find(
				'form:not([disabled]) ul.optionset:not([disabled]) li'
			),
			commentsLabel = el.find('.rating_comments label.left');

		stars.on({
			mouseenter: function() {
				$(this)
					.prevAll('li:not(.rating-hovered)')
					.andSelf()
					.addClass('rating-hovered');
			},
			mouseleave: function() {
				$(this)
					.prevAll('li')
					.andSelf()
					.removeClass('rating-hovered');
			},
			click: function() {
				manageSelected($(this));
			},
			keyup: function(e) {
				// Ensure correct stars are highlighted visually when navigating with keyboard
				switch (e.keyCode) {
					// Detect cursor keys
					case 37:
					case 38:
					case 39:
					case 40:
						manageSelected($(this));
						break;

					default:
                    // Do nothing for other keys
				}
			}
		});

		stars.on('click', function(e) {
			enableComments(el, e);
		});

		commentsLabel.on('click', function(e) {
			enableComments(el, e);
		});
	}

	function updateChecked() {
		$('ul.optionset input:checked').each(function() {
			var li = $(this).parent();
			li.prevAll('li')
				.andSelf()
				.addClass('rating-selected');

			li.off('mouseenter mouseleave click');
		});
	}

	function enableComments(el, e) {
		var stars = el.find(
				'form:not([disabled]) ul.optionset:not([disabled]) li'
			),
			comments = el.find('.rating_comments .middleColumn'),
			commentsLabel = el.find('.rating_comments label.left'),
			actions = el.find('.btn-toolbar');

		commentsLabel.addClass('sr-only');
		comments.addClass('active');
		actions.addClass('active');
		stars.off('click', enableComments);
		comments.off('click', enableComments);
	}

	function manageSelected(listItem) {
		var input = listItem.find('input');

		if (input.is(':checked')) {
			input.prop('checked', false);
			listItem
				.siblings('li')
				.andSelf()
				.removeClass('rating-selected');
		} else {
			input.prop('checked', true);
			listItem.nextAll('li').removeClass('rating-selected');
			listItem
				.prevAll('li')
				.andSelf()
				.addClass('rating-selected');
		}
		input.focus();
	}

	init();
});

/**
 * Show MailChimp subscribe form inside modal
 */
DO.Subscribe(['app:ready'], function (e, $) {
	'use strict';

	function init() {
		bindEvents();
	}

	/**
     * Bind modal trigger events, or load modal on detection of hash
     */
	function bindEvents() {
		$('[data-target="#subscribe_modal"]').on('click', function (e) {
			loadSubscribeModal();
		});

		if (window.location.hash === '#subscribe') {
			$('[data-target="#subscribe_modal"]').trigger('click');
		}
	}

	/**
     * Fetch Content for the modal
     */
	function loadSubscribeModal() {
		var modal = $('#subscribe_modal'),
			url = modal.attr('data-source'),
			title = document.title,
			location = window.location.href.split('#')[0];

		// Don't load form again if it's already there
		if (modal.hasClass('modal--active')) {
			return;
		}

		$('#subscribe_modal_content').html('');
		modal.addClass('modal--loading');

		$.ajax({
			url: url,
			type: 'get',
			success: function (html) {
				modal.removeClass('modal--loading');
				modal.find('#subscribe_modal_content').html($(html).find('#ajax_content'));

				// Add active class so we know not to send request
				// to load form again when it is closed and re-opened
				modal.addClass('modal--active');

				// Set focus to first field
				modal.find('input[type=email]').focus();

				bindSubscribeForm();
			},
			error: function (response) {
				console.log('Error: ' + response);
			}
		});

		modal.on('show.bs.modal', function (event) {
			// Set focus to close button when modal opens
			modal.find('.modal-close').focus();

			// Add class to <html> so we can disable scrolling on it
			// when modal is open otherwise duplicate scrollbars
			$('html').addClass('has_modal');
			history.replaceState(null, 'Subscribe', location + '#subscribe');
			document.title = 'Subscribe';
		});

		modal.on('hide.bs.modal', function (event) {
			$('html').removeClass('has_modal');
			history.replaceState(null, title, location);
			document.title = title;
		});
	}

	/**
     * Bind submission of the subscribe form
     */
	function bindSubscribeForm() {
		var modal = $('#subscribe_modal'),
			form = modal.find('form');

		form.off('submit').on('submit', function (e) {
			e.preventDefault();
			submitSubscribeForm();
		});
	}

	/**
     * handle submission of the subscribe form
     */
	function submitSubscribeForm() {
		var modal = $('#subscribe_modal'),
			form = modal.find('form'),
			url = form.attr('action'),
			data = form.serialize();

		$('#subscribe_modal_content').html('');
		modal.addClass('modal--loading');

		$.ajax({
			url: url,
			type: 'post',
			data: data,
			success: function (html) {
				modal.removeClass('modal--loading');
				$('#subscribe_modal_content').html($(html).find('#ajax_content'));
				modal.removeClass('modal--active');
			},
			error: function (response) {
				console.log('Error: ' + response);
				modal.removeClass('modal--active');
			}
		});
	}

	init();
});


DO.Subscribe(['app:ready', 'ajax:success'], function(e, $) {
	// DANGER - this means things might be being attached multiple times.
	$('[data-toggle="tooltip"]').tooltip({
		container: 'body',
		animation: true
	});
});

